import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import type { SignInConsent } from '@core/tellent-types';
import { SignInConsentStatus } from '@core/tellent-types';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [DatePipe],
  template: `<div [class.active]="this.row?.status === SignInConsentStatus.Active">
    {{ translations[row.status] }}
    {{
      (this.row?.status === SignInConsentStatus.Active ? row.expiresAt : row.revokedAt)
        | date: 'YYYY-MM-dd hh:mm '
    }}
  </div>`,
  styleUrl: './consent-status.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ConsentStatusComponent.NgInputs,
})
export class ConsentStatusComponent {
  public static readonly NgInputs = ['row' as const];
  private readonly i18n = inject(I18nService);
  protected readonly SignInConsentStatus = SignInConsentStatus;

  public translations: Partial<Record<SignInConsentStatus, string>> = {
    [SignInConsentStatus.Active]: this.i18n.translate(
      'tlc.current_user.grant_access.table.active_until',
    ),
    [SignInConsentStatus.Revoked]: this.i18n.translate(
      'tlc.current_user.grant_access.table.revoked_on',
    ),
  };
  public row: SignInConsent;
}
